import React from "react";
import Hero from "../../components/HomePageComponents/Hero/Hero";
import Agile from "../../components/HomePageComponents/Agile/Agile";
import Brand from "../../components/HomePageComponents/Brands/Brand";
import OutSourcingPartner from "../../components/HomePageComponents/OutSourcingPartner/OutSourcingPartner";
import Team from "../../components/HomePageComponents/Team/Team";
import ChooseSimform from "../../components/HomePageComponents/ChooseSimform/ChooseSimform";
import CultureCraft from "../../components/HomePageComponents/CultureCraft/CultureCraft";
import Award from "../../components/HomePageComponents/Award/Award";
import DigitalEng from "../../components/HomePageComponents/DigitalEng/DigitalEng";
import Gurantee from "../../components/HomePageComponents/Gurantee/Gurantee";
import AreaServe from "../../components/HomePageComponents/AreaServe/AreaServe";

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <Agile />
      <Brand />
      <OutSourcingPartner />
      <Team />
      <ChooseSimform />
      <CultureCraft />
      <Award />
      <DigitalEng />
      <Gurantee />
      <AreaServe />
    </div>
  );
};

export default Home;
